import React from 'react';
import Trophy from 'lucide-react/dist/esm/icons/trophy.js';
import Sparkles from 'lucide-react/dist/esm/icons/sparkles.js';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useTranslation } from '../../../utils/translations';
import { useContent } from '../../../contexts/ContentContext';
import { useEditMode } from '../../../contexts/EditModeContext';
import { useIsAdmin } from '../../../hooks/useIsAdmin';
import InlineTranslationEdit from '../../../components/InlineTranslationEdit';
import { useWinnersPage } from './WinnersPageContext';

export default function WinnersHeroSection() {
  const { language } = useLanguage();
  const { t } = useTranslation(language);
  const { c } = useContent();
  const { editMode, handleTranslationUpdate } = useEditMode();
  const { isAdmin } = useIsAdmin();
  const { gameType } = useWinnersPage();
  const inlineEditMode = editMode || isAdmin;
  const titleKey = `winners.hero.title.${gameType}`;
  const subtitleKey = `winners.hero.subtitle.${gameType}`;
  const legacyTitleKey = `winners.titles.${gameType}`;
  const legacySubtitleKey = `winners.subtitles.${gameType}`;
  const titleFallback = t(`winners.titles.${gameType}`, t('winners.title', 'Winners'));
  const subtitleFallback = t(`winners.subtitles.${gameType}`, t('winners.subtitle', 'Celebrating our lucky winners'));
  const titleValue = c(titleKey, c(legacyTitleKey, titleFallback));
  const subtitleValue = c(subtitleKey, c(legacySubtitleKey, subtitleFallback));

  return (
    <div className="text-center mb-12 animate-fade-in-up">
      <div className="flex items-center justify-center gap-3 mb-4">
        <div className="bg-gradient-to-br from-yellow-400 to-orange-500 p-3 rounded-2xl shadow-lg animate-bounce">
          <Trophy className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white">
          <InlineTranslationEdit
            translationKey={titleKey}
            value={titleValue}
            fallback={titleFallback}
            onUpdate={handleTranslationUpdate}
            editMode={inlineEditMode}
          />
        </h1>
        <Sparkles className="w-8 h-8 text-yellow-500 animate-pulse" />
      </div>
      <p className="text-base md:text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
        <InlineTranslationEdit
          translationKey={subtitleKey}
          value={subtitleValue}
          fallback={subtitleFallback}
          onUpdate={handleTranslationUpdate}
          editMode={inlineEditMode}
          multiline
        />
      </p>
    </div>
  );
}
